import React from 'react'
import './styles.scss'

export default function SubmitApplicationModal({
  show,
  onClose,
  onSubmit,
  submitting
}) {
  if (!show) return null

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h3>Submit Application</h3>
          <button className="close-btn" onClick={onClose}>✕</button>
        </div>
        <div className="modal-body">
          <p>
            Are you sure you want to submit your application? You won't be able to change your uploaded documents once it's under review.
          </p>
        </div>
        <div className="modal-footer">
          <button className="btn btn-outline" onClick={onClose} disabled={submitting}>Cancel</button>
          <button className="btn btn-primary" onClick={onSubmit} disabled={submitting}>
            {submitting ? 'Submitting...' : 'Submit Now'}
          </button>
        </div>
      </div>
    </div>
  )
}
